import { render, staticRenderFns } from "./SplitsPaymentsMethod.vue?vue&type=template&id=85c24132&scoped=true&"
import script from "./SplitsPaymentsMethod.vue?vue&type=script&lang=js&"
export * from "./SplitsPaymentsMethod.vue?vue&type=script&lang=js&"
import style0 from "./SplitsPaymentsMethod.vue?vue&type=style&index=0&id=85c24132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c24132",
  null
  
)

export default component.exports